import { Theme } from '@emotion/react';

import { Trans, useTranslation } from 'next-i18next';

import { IWaitfreeStoryDetail } from '../../model';
import { textColor } from '../../styles/css';
import { formatDuration } from '../../utils/date';
import DottedList from '../common/DottedList';
import Modal, { ModalButton, ModalProps } from '../common/Modal';

type Props = Pick<
  IWaitfreeStoryDetail,
  'waitfreeBlockCount' | 'waitfreeDuration'
>;

const mainTextCSS = (theme: Theme) => textColor(theme.colors.main500);

const WaitfreeInfoModal = ({
  waitfreeBlockCount,
  waitfreeDuration: waitfreeDurationInSeconds,
  ...props
}: Props & ModalProps) => {
  const { t } = useTranslation();

  const waitfreeDuration = formatDuration(waitfreeDurationInSeconds);

  const items = [
    <p className="multiline">
      <Trans t={t} i18nKey="기다리면 무료 모달 설명1">
        &lsquo;기다리면 무료&rsquo;로 회차를 보고{' '}
        <b css={mainTextCSS}>{{ waitfreeDuration }}</b>을 기다리면 1화씩{' '}
        <b css={mainTextCSS}>무료</b>로 공개됩니다.
      </Trans>
    </p>,
    <p className="multiline">
      <Trans t={t} i18nKey="기다리면 무료 모달 설명2">
        &lsquo;기다리면 무료&rsquo;는 1화를 <b css={mainTextCSS}>3일</b>
        동안 볼 수 있습니다.
      </Trans>
    </p>,
    <p className="multiline">
      <Trans t={t} i18nKey="기다리면 무료 모달 설명3">
        <b css={mainTextCSS}>
          <>최신 {{ waitfreeBlockCount }}화</>
        </b>
        는 &lsquo;기다리면 무료&rsquo; 대상이 아닙니다.
      </Trans>
    </p>,
  ];

  const filteredItems = waitfreeBlockCount === 0 ? items.slice(0, -1) : items;

  return (
    <Modal
      {...props}
      title={t('{{waitfreeDuration}}마다 1회차 무료', {
        waitfreeDuration,
      })}
    >
      <DottedList items={filteredItems} />
      <ModalButton text={t('확인')} />
    </Modal>
  );
};

export default WaitfreeInfoModal;
